module.exports = __webpack_public_path__ + "img/up-right-from-square.3d43267d.svg";